import { type ComponentPropsWithoutRef, type ReactElement } from 'react'

import { isEnumMember } from '@lib/utils/strings'

import { LogoSprites } from '@constants/enums/sprites'

export interface LogoProps extends ComponentPropsWithoutRef<'svg'> {
  variant: LogoSprites
}

export const logoSizes: Record<LogoProps['variant'], { width: number; height: number }> = {
  [LogoSprites.Superhuman]: {
    width: 168,
    height: 25,
  },
}

const isValidLogo = (key: string) => isEnumMember(key, LogoSprites)

export function Logo({ variant, ...rest }: LogoProps): ReactElement {
  const height = logoSizes?.[variant]?.height ?? 0
  const width = logoSizes?.[variant]?.width ?? 0

  if (!isValidLogo(variant)) {
    console.log(`Invalid sprite key (${variant}) passed to logo.`)
    return <></>
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      width={width}
      fill="currentColor"
      {...rest}
    >
      <use href={`#${variant}`} />
    </svg>
  )
}
